import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PermissionITF } from '@/authProvider'

interface AuthState {
  userToken: string
  permissions: PermissionITF | null
  permissionVersion: number
}

const INITIAL_STATE: AuthState = {
  userToken: '',
  permissions: null,
  permissionVersion: 0,
}

const authSlice = createSlice({
  name: 'auth',
  initialState: INITIAL_STATE,
  reducers: {
    setUserToken(state, action: PayloadAction<string>) {
      state.userToken = action.payload
    },
    setPermissions(state, action: PayloadAction<PermissionITF>) {
      state.permissions = action.payload
    },
    setPermissionVersion(state, action: PayloadAction<number>) {
      state.permissionVersion = action.payload
    },
    resetReducer: () => INITIAL_STATE,
  },
})

export const { setUserToken, setPermissions, setPermissionVersion, resetReducer } = authSlice.actions
export default authSlice.reducer
